import ProfileMain from './ProfileMain.component';

export default ProfileMain;